import { render, staticRenderFns } from "./LAndDRequestHistory.vue?vue&type=template&id=2bff1b92&scoped=true"
import script from "./LAndDRequestHistory.vue?vue&type=script&lang=js"
export * from "./LAndDRequestHistory.vue?vue&type=script&lang=js"
import style0 from "./LAndDRequestHistory.vue?vue&type=style&index=0&id=2bff1b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bff1b92",
  null
  
)

export default component.exports